import React from "react";
import detail from "../../assets/images/detail.png";
import { LoginForm } from "../Home/LoginForm";
import { RegisterPage } from "../Home/RegisterPage";
import Tabs from "../Tab/Tabs";
import account from "../../assets/svgs/account.svg"
import { DropdownList } from "./DropdownList";
import searcIcon from "../../assets/images/search.png";
import MobileSearchInput from "./MobileSearchInput"

class NavBarDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentDisplay: "none",
      show: false,
      user: null,
      activeTab: "Login",
    }; 
  }
  toggleContent = (e) => {
    if (this.state.contentDisplay === "none") {
      this.setState({ contentDisplay: "block" });
    } else {
      this.setState({ contentDisplay: "none" });
    }
  };
  componentDidMount() {
    const local_user = localStorage.getItem("user");
    if (local_user) {
      this.setState({ user: local_user });
    }
  }
  toggle = (e) => {
    this.setState({ activeTab: e });
    this.setState({ show: !this.state.show });
  };
  render() {
    return (
      <>
        <div className="navbardropdown">
          <div
            style={{
              display: "grid",
              gridTemplateAreas: "NavSpanButton NavHeader AccIcon",
              marginRight:"5px"
            }}
          >
            <button
              onClick={this.toggleContent}
              aria-label="icon"
              style={{
                backgroundColor: "transparent",
                color: "white",
                border: "none",
                fontWeight: "bold",
                fontSize: "16px",
                height: "60px",
                gridArea: "NavSpanButton",
                gridColumn: "1/2",
                alignItems: "center",
                alignContent: "start",
                display: "flex",
                padding: 0,
              }}
            >
              <img
                style={{
                  height: "40px",
                  width: "50px",
                  justifyContent: "center",
                }}
                alt="icon"
                src={detail}
              />
            </button>
            <div
              style={{
                display: "flex",
                position: "relative",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "white",
                fontSize: "24px",
                width: "33vw",
                padding: 0,
                margin: 0,
                gridArea: "NavHeader",
                gridColumn: "2/3",
              }}
            >
              <a
                href="/"
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  color: "white",
                  textAlign: "center",
                  fontSize: "18px"
                }}
              >
                ML & Practices
              </a>
            </div>{this.state.user &&
              <a
                href="/account"
                style={{
                  display: "flex",
                  position: "relative",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "end",
                  color: "white",
                  fontSize: "24px",
                  width: "100%",
                  padding: 0,
                  margin: 0,
                  gridArea: "AccIcon",
                  gridColumn: "3/4",
                  color: "white"
                }}><img style={{ color: "white" }} src={account} /></a>}
                {!this.state.user &&
              <div
                href="/account"
                style={{
                  display: "flex",
                  position: "relative",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "end",
                  color: "transparent",
                  fontSize: "24px",
                  width: "100%",
                  padding: 0,
                  margin: 0,
                  gridArea: "AccIcon",
                  gridColumn: "3/4",
                  color: "white"
                }}></div>}
          </div>
          <div
            style={{
              borderTop: "solid 1px white",
              display: this.state.contentDisplay,
              // paddingLeft: "15px",
            }}
            className="navbardropdown-content"
          >
            {!this.state.user && (
              <><div className="dropdown-item" style={{ width: "fit-content", marginLeft: "10px", backgroundColor:"transparent" }}>
                <button
                  className="login-button"
                  onClick={() => this.toggle("Login")}
                >
                  Login |
                </button>
                <button
                  className="signup-button"
                  onClick={() => this.toggle("SignUp")}
                >
                  SignUp
                </button></div>
              </>
            )}
            {this.state.user && (
              <>
                <a
                  href="/account"
                  style={{
                    display: "flex",
                    // alignItems: "end",
                    // textAlign: "end",
                    // alignContent: "end",
                    justifyContent: "start",
                    width: "100%",
                  }}
                >
                  {/* <div><img src={account} /></div> */}
                  <div
                    style={{
                      fontWeight: "bold",
                      marginLeft: "5px",
                    }}
                  >
                    {this.state.user.username}
                  </div>
                </a>
              </>
            )}
            <a
              className="navbardropdown-item"
              style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }}
              rel="noopener noreferrer"
              href="/about"
            >
              About
            </a>
            <a
              className="navbardropdown-item"
              style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }}
              rel="noopener noreferrer"
              href="/contact"
            >
              Contact
            </a>
            <a
              className="navbardropdown-item"
              style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }}
              href="/support"
            >
              Support
            </a>
            <a
              className="navbardropdown-item" href="/tictac" style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }} >
              Tictac
            </a>
            <a
              className="navbardropdown-item" href="/service" style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }} >
              Offer me
            </a>
            {/* <a
              className="navbardropdown-item"
              href="/sample" style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }}>
              Samples
            </a> */}
            {/* <a
              className="navbardropdown-item"
              href="/update" style={{
                fontSize: 12,
                textDecoration: "underline",
                paddingTop: "5px",
              }}>
              Updates
            </a> */}
            <DropdownList />
            <MobileSearchInput
              custom_style={{
                width: "100%",
                border: "solid 1px grey",
                borderRadius: "5px",
                // width: "50%",
                alignItems: "end",
                height: "30px",
                marginTop: "10px",
                backgroundImage: searcIcon
              }}
            />
          </div>
        </div>
        {this.state.show && (
          <Tabs showIndex={this.state.activeTab}>
            <div label="Login" style={{ fontWeight: "bold" }}>
              <LoginForm />
            </div>
            <div label="SignUp" style={{ fontWeight: "bold" }}>
              <RegisterPage />
            </div>
          </Tabs>
        )}
      </>
    );
  }
}

export default NavBarDropdown;
